import { useMutation } from '@tanstack/react-query';
import { reservationApi } from '@/api/reservations';
import type { OnlineReservationDto } from '@/types';

/**
 * React Query mutation hook to create a reservation
 */
export function useCreateReservation(storeDomain: string | null) {
  return useMutation({
    mutationFn: (data: OnlineReservationDto) => {
      if (!storeDomain) {
        throw new Error('Store domain is required');
      }
      return reservationApi.createReservation(storeDomain, data);
    },
    retry: false, // Don't retry failed reservation submissions
  });
}
